import React, { useEffect } from 'react';
import * as firebase from 'firebase';
import {
  BrowserRouter as Router,
  useLocation,
  useHistory
} from "react-router-dom";
import moment from 'moment';
import '../view/css/AffiliateEvents.css'
import {AffiliateEventsView} from '../view/AffiliateEventsView';

export function AffiliateEvents(props) {

  const [eventy, setEvents] = React.useState([]);
  const [stop_store_event, setStore] = React.useState(false);
  const [type_1, setType] = React.useState("");
  const [check_affiliate, setCheckAffiliate] = React.useState(false);
  let history = useHistory();

  var firestore = firebase.firestore();
  const user = firebase.auth().currentUser;
  const location = useLocation();

 useEffect(() =>{
   get_events();
 },[]);
 
  const get_events = async () => {
    const array_event = [];
    var stop_rend = false;
    const new_array = [];

    const today_date = moment(new Date().now);
    firebase.auth().onAuthStateChanged(function(user) {
      if (user != null) {
        
      const db = firestore.collection("Users").doc(user.email);
      console.log("do i even check")
      const doc = db.get().then(function (doc) {
        if (doc.exists) {
          console.log("thats rrriiight")
          setType(doc.data().type)
          if (doc.data().type === "Affiliate") {
            setCheckAffiliate(true);
          }
        }
      })
      } else {
        console.log('oggagaga')
      }
    });

    console.log(user);
    const ab = firestore.collection("Event");
    const query = ab.orderBy("event_start");
    try{
      console.log("OOGABOOGA?")
      console.log("WDYMSMDMS")
      const trying = await ab.get();
      trying.forEach(doc =>{
        const doccer = doc.data();
        const sub_name = location.state.id

        const start_date = moment(doccer.event_start.toDate());
        const end_date = moment(doccer.event_end.toDate());

        if (doccer.Affiliate === sub_name && ((start_date.isSameOrAfter(today_date)) || (end_date.isAfter(today_date)))) {
          console.log(doc.data().event_title)
          array_event.push({
            title: doccer.event_title,
            location: doccer.location,
            description: doccer.description,
            start: start_date.format("MMM D, YYYY [at] h:mm a"),
            end: end_date.format("MMM D, YYYY [at] h:mm a"),
            tags: doccer.tags,
            affiliate: doccer.username,
            email: doccer.Affiliate,
            pictures: doccer.picture
          })
        }
        let unique = array_event.filter((e, i) => array_event.indexOf(e) === i);
        stop_rend = true;
        setEvents(unique)
      })
  
    }catch (err) {
      console.log('Error getting documents', err);
  }
    
    setStore(true);
  }

  return (
    <AffiliateEventsView eventy={eventy} type_1={type_1} check_affiliate={check_affiliate} history={history.goBack}/>
  )
}


